import React, { useEffect, useState } from 'react';
import './App.css';
import { Link } from 'react-router-dom';

function ListadoEmpleos() {
  const [empleos, setEmpleos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("Todas");
  const [filtroPais, setFiltroPais] = useState("Todos");
  const [filtroProvincia, setFiltroProvincia] = useState("Todas");
  const [filtroCronologia, setFiltroCronologia] = useState("Todas");
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  useEffect(() => {
    fetch("https://opensheet.elk.sh/1eiyc-JP3WiO8NkO6Yf5FpoRpcysiTETtlLGmXLm50X8/Hoja1")
      .then((res) => res.json())
      .then((data) => {
        const visibles = data.filter((e) => e.visible?.toLowerCase() === "sí");
        setEmpleos(visibles);
      });
  }, []);

  const empleosFiltrados = empleos.filter((e) => {
    const texto = `${e.puesto} ${e.ciudad} ${e.categoría} ${e.cronologías}`.toLowerCase();
    const coincideBusqueda = texto.includes(busqueda.toLowerCase());
    const coincideCategoria = filtroCategoria === "Todas" || e.categoría === filtroCategoria;
    const coincidePais = filtroPais === "Todos" || e.país === filtroPais;
    const coincideProvincia = filtroProvincia === "Todas" || e.provincia === filtroProvincia;
    const coincideCrono = filtroCronologia === "Todas" || (e.cronologías || "").includes(filtroCronologia);
    return coincideBusqueda && coincideCategoria && coincidePais && coincideProvincia && coincideCrono;
  });

  const categorias = [...new Set(empleos.map(e => e.categoría).filter(Boolean))];
  const paises = [...new Set(empleos.map(e => e.país).filter(Boolean))];
  const provincias = filtroPais === "Todos"
    ? []
    : [...new Set(empleos.filter(e => e.país === filtroPais).map(e => e.provincia).filter(Boolean))];
  const cronos = [...new Set(empleos.flatMap(e => (e.cronologías || "").split(',').map(c => c.trim())))];

  const limpiarFiltros = () => {
    setBusqueda("");
    setFiltroCategoria("Todas");
    setFiltroPais("Todos");
    setFiltroProvincia("Todas");
    setFiltroCronologia("Todas");
  };

  return (
    <>
      <div className="navbar">
      <div className="left">
          <Link to="/" className="logo-link">Didaskia</Link>
      </div>
      <div className="right">
        <Link to="/enviar">Envía Oferta</Link>
        <Link to="/info">Info</Link>
        <Link to="/login">Login</Link>
      </div>
    </div>

      <div className="main-layout">
        <button
          className="toggle-filtros"
          onClick={() => setMostrarFiltros(prev => !prev)}
        >
          {mostrarFiltros ? "🔼 Ocultar filtros" : "🔽 Mostrar filtros"}
        </button>
        <aside className={`sidebar ${mostrarFiltros ? "visible" : ""}`}>
          <h3>🔍 Filtros</h3>
          <p>Encuentra tu trabajo ideal</p>

          <input
            type="text"
            placeholder="Título o empresa..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />

          <label>País o remoto</label>
          <select value={filtroPais} onChange={(e) => {
            setFiltroPais(e.target.value);
            setFiltroProvincia("Todas"); // Reinicia provincia al cambiar país
          }}>
            <option>Todos</option>
            {paises.map((p) => <option key={p}>{p}</option>)}
          </select>

          {provincias.length > 0 && (
            <>
              <label>Provincia</label>
              <select value={filtroProvincia} onChange={(e) => setFiltroProvincia(e.target.value)}>
                <option>Todas</option>
                {provincias.map((prov) => <option key={prov}>{prov}</option>)}
              </select>
            </>
          )}

          <label>Categoría</label>
          <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
            <option>Todas</option>
            {categorias.map((cat) => <option key={cat}>{cat}</option>)}
          </select>

          <label>Cronología</label>
          <select value={filtroCronologia} onChange={(e) => setFiltroCronologia(e.target.value)}>
            <option>Todas</option>
            {cronos.map((c) => <option key={c}>{c}</option>)}
          </select>

          <button className="reset-button" onClick={limpiarFiltros}>
            🧽 Limpiar filtros
          </button>
        </aside>

        <div className="job-section">
          <h1>Ofertas de empleo arqueológico</h1>

          {empleosFiltrados.length === 0 ? (
            <p>No hay empleos que coincidan con los filtros.</p>
          ) : (
            <div className="job-list">
              {empleosFiltrados.map((empleo) => (
                <Link
                  key={empleo.id}
                  to={`/empleo/${empleo.id}`}
                  className="job-card"
                >
                  <div className="job-icon">
                    {empleo.empresa?.trim().charAt(0) || "?"}
                  </div>

                  <div className="job-info">
                    <h3>{empleo.puesto}</h3>
                    <p className="empresa">{empleo.empresa}</p>

                    <div className="job-meta">
                      <button
                        className="tag-button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setFiltroPais(empleo.país);
                        }}
                      >
                        📍 {empleo.ciudad}, {empleo.país}
                      </button>
                      <span className="fecha">📅 {empleo.fecha_publicación}</span>
                    </div>

                    <div className="job-tags">
                      {empleo.categoría && (
                        <button
                          className="tag"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setFiltroCategoria(empleo.categoría);
                          }}
                        >
                          {empleo.categoría}
                        </button>
                      )}
                      {(empleo.cronologías || "").split(',').map((cr, i) => (
                        <button
                          className="tag"
                          key={i}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setFiltroCronologia(cr.trim());
                          }}
                        >
                          {cr.trim()}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="job-salary">
                    {empleo.salario && <strong>{empleo.salario}</strong>}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ListadoEmpleos;
